import {
  // createSimpleTransition,
  createJavaScriptTransition
} from '../../util/helpers';



import ExpandTransitionGenerator from './expand-transition';



const ExpandTransition = createJavaScriptTransition('expand-transition', ExpandTransitionGenerator());



export default {
  ExpandTransition,
}



// WEBPACK FOOTER //
// ./src/js/ui/components/transitions/index.js